<template>
    <div>
        <v-card elevation="0">
            <v-card-title> <v-icon color="#01579B">mdi-finance</v-icon>&nbsp;{{ getUserName }}'s Fund Balances</v-card-title>
            <v-card-text>
                <br />
                <div v-if="renderok">
                    <div v-if="entryExist">
                        <v-row>
                            <v-col md="4">
                                <v-card elevation="0" color="#E1F5FE" height="500">
                                    <v-card-text>
                                        <div style="color: black;">Last Updated: {{ lastUpdated }}</div> <br />
                                        <v-select
                                            v-model="selectedBudget"
                                            hint="Select Budget Type you would like to view"
                                            :loading="selectloading"
                                            :items="budgetTypes"
                                            item-text="label"
                                            item-value="prefix"
                                            label="Budget Type"
                                            persistent-hint
                                            outlined
                                            return-object
                                            @change="changeView()"
                                        ></v-select><br />
                                        <div v-if="graphRender">
                                            <v-simple-table>
                                                <template v-slot:default>
                                                    <tbody>
                                                        <tr>
                                                            <th class="text-left" colspan="2" style="color: white; background-color: #01579B;"> {{ selectedBudget.label }} </th>
                                                        </tr>
                                                        <tr>
                                                            <th class="text-left">
                                                                Budget
                                                            </th>
                                                            <td>$ {{ chosenfaData.budget }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="text-left">
                                                                Actual
                                                            </th>
                                                            <td>$ {{ chosenfaData.actual }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="text-left">
                                                                Available
                                                            </th>
                                                            <td>$ {{ chosenfaData["available-real"] }}</td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col md="8">
                                <v-card elevation="0" outlined height="500">
                                    <v-card-text>
                                        <DoughnutChart :faData="chosenfaData" :budgetType="selectedBudget" v-if="graphRender"/>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <br /><br />
                            <v-col md="12">
                                <v-alert type="info" outlined>
                                    For any questions regarding the fund information as presented or for detailed financial analysis, please 
                                    <a href="https://mykings.ca/intranet/app/#/its/its-service-request" target="_blank">submit a support ticket</a>.
                                </v-alert>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else-if="!entryExist" style="font-size: large; color: black; padding-left: 20px;">
                        <br />
                        <v-alert type="warning" prominent outlined>
                            No budgets have been assigned to you. <br />
                            For any questions regarding the fund information as presented or for detailed financial analysis, please 
                            <a href="https://mykings.ca/intranet/app/#/its/its-service-request" target="_blank">submit a support ticket</a>.
                        </v-alert>
                    </div>
                </div>
                <v-container style="height: 450px;" v-else-if="!renderok">
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                        <v-col
                            class="text-subtitle-1 text-center"
                            cols="12"
                        >
                            Loading fund balances...
                        </v-col>
                        <v-col cols="6">
                            <v-progress-linear
                                color="green"
                                indeterminate
                                rounded
                                height="6"
                            ></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            color="#004236"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import auth from '../../js/auth.js';
import DoughnutChart from './DoughnutChart.vue';

export default {
    components: {
        DoughnutChart
    },
    data(){
        return{
            host: location.hostname.toString(),
            renderok: false,
            lastUpdated: "",
            budgetTypes: [],
            selectedBudget: "",
            selectloading: false,
            faData: [],
            chosenfaData: [],
            graphRender: false,
            snackbar: false,
            text: "",
            timeout: 3500,
            entryExist: true
        }
    },
    methods: {
        callFAData(){
            const that = this;
            let api= 'https://'+that.host+'/cgi-bin/fin-info-api/api.py?mode=getFAdata';
            that.selectloading = true;
            that.graphRender = false;
            //API GET request
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/OK/i)){
                        if(resultData.message.match(/^Could not resolve empcode/i)){
                            that.entryExist = false;
                            that.renderok = true;
                        }else {
                            that.setSnackbar(resultData.result+": "+resultData.message);
                        }
                    }else {
                        if(resultData.data){
                            if(!resultData.data.empcode){
                                that.entryExist = false;
                                that.renderok = true;
                                that.setSnackbar("Data calling successful!");
                            }else {
                                that.faData = resultData.data;
                                that.budgetTypes = resultData.data.budgets;

                                that.selectedBudget = that.budgetTypes[0];

                                that.setBudgetDataValue(that.selectedBudget.prefix);

                                that.setTimeFormat_TS(parseInt(resultData.data["import-timestamp-js"])); //Uses timestamp
                                that.renderok = true;
                                that.entryExist = true;
                                that.graphRender = true;
                                that.setSnackbar("Data calling successful!");
                            }
                            
                        }
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString());
                })
            //End of API GET request

            that.selectloading = false;
        },
        changeView(){
            const that = this;
            that.graphRender = false;
            that.chosenfaData = [];

            setTimeout(function() {
                //Re-renders the view with the new data
                that.setBudgetDataValue(that.selectedBudget.prefix);

                that.graphRender = true;
            }, 300);

        },
        setBudgetDataValue(budgetType){
            //I have read that .toFixed() may be buggy sometimes, but I believe it will be okay for 99.99% for our cases.
            const that = this;
            var available = 0.00;

            if(parseFloat(that.faData[budgetType+"-available"]) < parseFloat(0)){
                available = parseFloat(0).toFixed(2);
            }else {
                available = parseFloat(that.faData[budgetType+"-available"]).toFixed(2);
            }

            var data = {
                        "budget": parseFloat(that.faData[budgetType+"-budget"]).toFixed(2),
                        "actual": parseFloat(that.faData[budgetType+"-actual"]).toFixed(2),
                        "available": available,
                        "available-real" : parseFloat(that.faData[budgetType+"-available"]).toFixed(2)
                }

            that.chosenfaData = data;
        },
        setSnackbar(msg){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.text = msg;
        },
        setTimeFormat_TS(time){ //Uses Timestamp to convert to user-friendly date
            const that = this;
            var date = new Date(time);
            var stringDate = date.toLocaleString();

            that.lastUpdated = stringDate;
        }
    },
    computed: {
        //Maybe take out if Home is in use
        getUserName() {
            let user = auth.get_user();

            return `${user.fullname}`;
        }
    },
    created(){
        const that = this;
        that.callFAData();
    }
}
</script>
